import {
    REPURCHASE_RATE_SUCCESS,
    REPURCHASE_RATE_LOADING

} from '../actions/RepurchaseRateAction';

const initialState = {
    amazon: {
        repurchaseRateData: null,
        isLoading: true,
    },
    shopify: {
        repurchaseRateData: null,
        isLoading: true,
    },
    wholesale: {
        repurchaseRateData: null,
        isLoading: true,
    },
};

const RepurchaseRateReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case REPURCHASE_RATE_SUCCESS:
            return {
                ...state, [action?.vendor]: { repurchaseRateData: action.data, isLoading: false }
            };

        case REPURCHASE_RATE_LOADING:
            return { ...state, [action?.vendor]: { ...state?.[action?.vendor], isLoading: action.isLoading } };

        default:
            return state;
    }
};

export default RepurchaseRateReducer;
